import cn from 'clsx';
import React from 'react';

import s from './SectionDescription.module.scss';
import { SectionDescriptionProps } from './SectionDescription.types';

const SectionDescription = ({ text, bgType, className, ...props }: SectionDescriptionProps) => {
  return (
    <section className={cn(s.section, bgType === 'BgGray' && s.bg_gray, className)} {...props}>
      <p className={s.text_area}>{text}</p>
    </section>
  );
};

export default SectionDescription;
